import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Radio as RadioBase, RadioProps } from '@mui/material';
import { ReactComponent as RadioCheckedIcon } from '../../assets/radio-checked.svg';
import { ReactComponent as RadioIcon } from '../../assets/radio.svg';

const StyledRadio = styled(RadioBase)`
  &.MuiRadio-root {
    ${({ disabled }) => disabled && 'opacity: 0.4'};
    :hover {
      background: none;
    }
  }
`;

const Radio = forwardRef((props: RadioProps, ref: any) => (
  <StyledRadio
    ref={ref}
    {...props}
    icon={<RadioIcon />}
    checkedIcon={<RadioCheckedIcon />}
  />
));

export default Radio;
